import { render, staticRenderFns } from "./vega-sicilia.vue?vue&type=template&id=dd66c99c&scoped=true"
import script from "./vega-sicilia.vue?vue&type=script&lang=js"
export * from "./vega-sicilia.vue?vue&type=script&lang=js"
import style0 from "./vega-sicilia.vue?vue&type=style&index=0&id=dd66c99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd66c99c",
  null
  
)

export default component.exports